import axios  from "axios"

const apiUrl = localStorage.getItem('CF_BASE_URL')?.replace("/admin", "") || process.env.VUE_APP_BASE_URL?.replace("/admin", "");

export default {

   async getLoanApplications(params){
    try{
        const {data} = await axios.get(`${apiUrl}/finance/loan-application`, {params})
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error.response);
        }
    },
    async getLoanApplicationById(id){
        try{
            const {data} = await axios.get(`${apiUrl}/finance/loan-application/${id}`)
            return Promise.resolve(data);
        }catch(error){
            return Promise.reject(error.response);
        }
    },
    async getLoanPrograms(params){
        try{
            const {data} = await axios.get(`${apiUrl}/finance/loan-program`, {params})
            return Promise.resolve(data);
        }catch(error){
            return Promise.reject(error.response);
        }
    },
    async updateLoanApplication(id, payload){
        try{
            const {data} = await axios.put(`${apiUrl}/finance/loan-application/${id}`, payload)
            return Promise.resolve(data);
        }catch(error){
            return Promise.reject(error.response);
        }
    },
    async createLoanApplicationAdditionalInfo(payload) {
        try {
            const { data } = await axios.post(
                `${apiUrl}/finance/loan-application/additional-info`,
                payload,
            );
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error.response);
        }
    },
    async patchLoanApplicationStatus(id, payload) {
        try {
            const { data } = await axios.patch(
                `${apiUrl}/finance/loan-application/${id}/status`,
                payload,
            );
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error.response);
        }
    },
    async getDashboardMetrics(params) {
        try {
            const { data } = await axios.get(`${apiUrl}/finance/dashboard/metrics`, { params });
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async getLoanApplicationsChart(params) {
        try {
            const { data } = await axios.get(`${apiUrl}/finance/dashboard/loan-applications`, { params });
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async getAverageLoanAmountChart(params) {
        try {
            const { data } = await axios.get(`${apiUrl}/finance/dashboard/average-loan-amount`, { params });
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },

    async getApplicationsByRegionChart(params) {
        try {
            const { data } = await axios.get(`${apiUrl}/finance/dashboard/applications-by-region`, { params });
            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err.response);
        }
    },
    async createLoanApprovalDetails(payload) {
        try {
            const { data } = await axios.post(
                `${apiUrl}/finance/loan-application/approval`,
                payload,
            );
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error.response);
        }
    },
    async updateDisbursementPaymentDetails(id, payload) {
        try {
            const { data } = await axios.put(
                `${apiUrl}/finance/loan-application/approval/disbursement/${id}`,
                payload,
            );
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error.response);
        }
    }
}